import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import TextInput from "../../widgets/TextInput";
import addInsegnante from '../../services/addInsegnante';
import FixButton from "../../widgets/Button";
import Utils from '../../utils/utils';
import addUtente from '../../services/addUtente';
import translateString from "../../utils/Locales";
import checkUserToken from "../../services/checkUserToken";
import SelectInput from '../../widgets/SelectInput';
import addAnagraficaFatture from "../../services/addAnagraficaFatture";
import getClient from "../../services/getClient";

let t = translateString;

export default class AddInsegnante extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      nome: '',
      cognome: '',
      mail: '',
      mail2Tipo: '',
      mail2: '',
      indirizzo: '',
      citta: '',
      codiceFiscale: '',
      piva: '',
      telefono: '',
      telefono2Tipo: '',
      telefono2: '',
      isSmallScreen: false,
    }

    this.grid = 2;

    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();
    this.selectRef = React.createRef();

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });

  }

  handleResize() {
      if (window.innerWidth <= 1100) {
        this.setState({ isSmallScreen: true });
      } else {
        this.setState({ isSmallScreen: false });
      }
  }

  async componentDidMount(){
    window.addEventListener('resize', this.handleResize.bind(this));
    this.handleResize();

    Utils.setAnalyticsPage('Teacher creation - ' + new Cookies().get('db', { path: '/' }));
    this.sessoArray = [];

    this.sessoArray.push({ value: 'M', label: t('M') });
    this.sessoArray.push({ value: 'F', label: t('F') });
    this.sessoArray.push({ value: 'A', label: t('A') });

    this.setState({ sessoArray: this.sessoArray, sesso: { value: 'A', label: t('A') } });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  render () {

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('aggiungi_insegnante')} />
        <p style={{ color: 'darkgray', fontWeight: 'lighter', marginBottom: 10, marginLeft: 5 }}>{t('campi_obbligatori')}</p>

        <div style={{ display: this.state.isSmallScreen ? 'block' : 'flex' }}>
            <div>
                <TextInput name={t('nome') + ' (*)'} value={this.state.nome} 
                onChange={(text) => { this.setState({nome: text})}
              } />
              <TextInput name={t('cognome') + ' (*)'} value={this.state.cognome} 
                onChange={(text) => { this.setState({cognome: text})}
              } />

            <div style={{ marginTop: 2 }} key={Math.random()}>
              <SelectInput 
                ref={this.selectRef}
                value={this.state.sesso} 
                name={t('sesso')} 
                hidable={false}
                options={this.state.sessoArray} 
                onChange={(option) => 
                    this.setState({ sesso: option })} 
                />
            </div>

              <TextInput name={'Mail'} value={this.state.mail} 
                onChange={(text) => { this.setState({mail: text})}
              } />
              <TextInput name={'Mail 2'} value={this.state.mail2} 
                onChange={(text) => { this.setState({mail2: text})}
              } />     
               <TextInput name={t('indirizzo')} value={this.state.indirizzo} 
                onChange={(text) => { this.setState({indirizzo: text})}
              } />       

            </div>
            <div style={{ marginLeft: this.state.isSmallScreen ? 0 : '20px' }}>
             
              <TextInput name={t('citta')} value={this.state.citta} 
                onChange={(text) => { this.setState({citta: text})}
              } />
              <TextInput name={t('codice_fiscale')} value={this.state.codiceFiscale} 
                onChange={(text) => { this.setState({codiceFiscale: text})}
              } />
               <TextInput name={t('p_iva')} value={this.state.piva} 
                onChange={(text) => { this.setState({piva: text})}
              } />
              <TextInput name={t('telefono')} value={this.state.telefono} 
                onChange={(text) => { this.setState({telefono: text})}
              } />
              <TextInput name={t('telefono') + ' 2'} value={this.state.telefono2} 
                onChange={(text) => { this.setState({telefono2: text})}
              } />
              <TextInput name={t('telefono_note')} value={this.state.telefono2Tipo} 
                onChange={(text) => { this.setState({telefono2Tipo: text})}
              } />
        </div>
        </div>  
        <br/>
        <div className="save">
            <FixButton title={t('salva')} callback={this.save.bind(this)} />
        </div>
        <br/><br/><br/>
        </LoadingOverlay>
      </>
    );
  }

  async save() {

      if (this.state.nome !== '' && this.state.nome !== undefined && this.state.cognome !== '' && this.state.cognome !== undefined) {
          
          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });

          let ret = await addInsegnante (username, token, this.state.cognome, this.state.nome, this.state.sesso.value, this.state.corsi, this.state.mail, '', this.state.mail2, 
            this.state.indirizzo, this.state.citta, this.state.codiceFiscale, this.state.piva, this.state.telefono, this.state.telefono2Tipo, this.state.telefono2);

          var newUsername = await Utils.generateUsername(username, token, this.state.nome, this.state.cognome);
          var password = Utils.generatePassword();
          var sec_token = Utils.generateUserToken();
          var res = await checkUserToken(username, token, sec_token);
          while(res.result !== 'ok') {
              sec_token = Utils.generateUserToken();
              res = await checkUserToken(username, token, sec_token);
          }
          await addUtente(username, token, '', '', newUsername, password, 2, ret.id, sec_token);
          let cliente = await getClient('', '', cookies.get('db', { path: '/' }));
          if (cliente.fatturazione_attiva === '1') {
              await addAnagraficaFatture(username, token, ret.id, 'fornitori', this.state.nome + ' ' + this.state.cognome, this.state.indirizzo, this.state.citta, this.state.mail, this.state.telefono, this.state.codiceFiscale, this.state.piva);
          }

          if (ret.result == 'ok') {
            window.location.href =  '/' + this.dbPath + '/#/app/insegnanti';
          } else {
            Utils.showError(t('errore_insegnante'));
          }
      } else {
          Utils.showError(t('verifica_dati'));
      }
  }

}

